<template>	
	<div class="overlay">
		<div class="overlay-content alert alert-danger">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-12 h5 text-center">
					{{ text }}
				</div>
				<div class="col-12">
					<button class="btn btn-lg btn-warning" @click.prevent="close">
						Bezárás
					</button>
				</div>
				<div class="col-12">
					<hr>
				</div>
				<div class="col-12 col-sm-12 col-md-3 text-center h5" v-for="(item,index) in errors">
					{{item}}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'save_error',
	props: ['errors','text'],
	methods: {
		close(){
			this.$emit('close')
		}
	}
}
</script>
<style scoped>
.overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 10;
}

.overlay-content {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/components/save_error.vue